module.exports = __webpack_public_path__ + "img/banner-img1.b91db2a9.jpg";